import { render, staticRenderFns } from "./general-nav.vue?vue&type=template&id=a07e810e"
import script from "./general-nav.vue?vue&type=script&lang=js"
export * from "./general-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports